import { MenuItem, TextField } from '@mui/material';
import { SubscribedPortfolio } from '../../../../types/subscribedPortfolio';

type TreasuryPortfolioSelectProps = {
  portfolios: SubscribedPortfolio[];
  value: number | '';
  onChange: (portfolioId: number) => void;
  isLoading?: boolean;
  disabled?: boolean;
};

/** Picks one of the company's treasury portfolios (the subscribed portfolio id thriftplan redeems from). */
export const TreasuryPortfolioSelect = ({
  portfolios,
  value,
  onChange,
  isLoading,
  disabled,
}: TreasuryPortfolioSelectProps) => {
  let helperText = ' ';

  if (isLoading) {
    helperText = 'Loading the treasury portfolios…';
  } else if (!portfolios.length) {
    helperText = 'The owner has no treasury portfolio yet.';
  }

  return (
    <TextField
      select
      fullWidth
      size="small"
      label="Treasury Portfolio"
      value={value}
      onChange={(event) => onChange(Number(event.target.value))}
      disabled={disabled || isLoading || !portfolios.length}
      helperText={helperText}
    >
      {portfolios.map((portfolio) => (
        <MenuItem key={portfolio.id} value={portfolio.id}>
          #{portfolio.id} — {portfolio.nameEn}
          {portfolio.status?.name ? ` (${portfolio.status.name})` : ''}
        </MenuItem>
      ))}
    </TextField>
  );
};
